import React, { useRef, useEffect, useState } from 'react'
import styles from './HeroSection.module.css'
import { useLang } from '../../i18n/LanguageContext'

export default function HeroSection() {
  const { T } = useLang()
  const videoRef = useRef(null)
  const [videoLoaded, setVideoLoaded] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)')
    setIsMobile(mq.matches)
    const onChange = (e) => setIsMobile(e.matches)
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [])

  useEffect(() => {
    const video = videoRef.current
    if (!video || isMobile) return
    const tryPlay = () => { video.play().catch(() => {}) }
    if (video.readyState >= 3) tryPlay()
    else video.addEventListener('canplaythrough', tryPlay, { once: true })
  }, [isMobile])

  const stats = T.hero.stats

  return (
    <section className={styles.hero} id="hero">
      {!isMobile && (
        <div className={`${styles.videoBg} ${videoLoaded ? styles.videoVisible : ''}`}>
          <video
            ref={videoRef}
            autoPlay muted loop playsInline preload="auto"
            poster="/bg-banner.png"
            onCanPlay={() => setVideoLoaded(true)}
          >
            <source src="/hero.webm" type="video/webm" />
            <source src="/hero.mp4"  type="video/mp4"  />
          </video>
        </div>
      )}

      <div
        className={`${styles.imageBg} ${videoLoaded && !isMobile ? styles.imageFaded : ''}`}
        style={{ backgroundImage: 'url(/bg-banner.png)' }}
        aria-hidden="true"
      />
      <div className={styles.overlay} aria-hidden="true" />
      <div className={styles.grid} aria-hidden="true" />

      <div className={`container ${styles.content}`}>
        <div className={styles.eyebrow}>
          <span className={styles.eyebrowDot} />
          {T.hero.eyebrow}
        </div>

        <h1 className={styles.heading}>
          {T.hero.heading1}
          <br />
          <span className={styles.headingAccent}>{T.hero.headingAccent}</span>
        </h1>

        <p className={styles.subtext}>{T.hero.subtext}</p>

        <div className={styles.actions}>
          <a href="#contato" className="btn btn-primary">
            {T.hero.ctaPrimary}
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
          <a href="https://elos.eqpitech.com.br" target="_blank" rel="noopener noreferrer" className="btn btn-outline">
            {T.hero.ctaSecondary}
          </a>
        </div>
      </div>

      <div className={styles.statsBar}>
        <div className="container">
          <div className={styles.statsGrid}>
            {stats.map((s, i) => (
              <div key={i} className={styles.statItem}>
                <span className={styles.statValue}>{s.value}</span>
                <span className={styles.statLabel}>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
